import { useRef, useState, ChangeEvent } from 'react';
import { adjustTextareaHeight } from '../utils/chatUtils';
import { shouldSendMessage, getAndClearInput } from '../utils/inputUtils';

export const useChatInput = (onSubmit: () => void) => {
  const [isComposing, setIsComposing] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const onTextareaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (textareaRef.current) {
      adjustTextareaHeight(textareaRef.current);
    }
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (shouldSendMessage(e, isComposing)) {
      e.preventDefault();
      onSubmit();
    }
  };

  const onCompositionStart = () => {
    setIsComposing(true);
  };

  const onCompositionEnd = () => {
    setIsComposing(false);
  };

  const getCurrentInput = () => (textareaRef.current ? getAndClearInput(textareaRef.current) : '');

  return {
    textareaRef,
    onTextareaChange,
    onKeyDown,
    onCompositionStart,
    onCompositionEnd,
    getCurrentInput,
  };
};
